import { h } from "preact";
import { navigateTo } from "../navigateTo";

const itemUrl = (item) => `/item/${item.id}`;

export const ItemLink = ({ item, text }) => <a onClick={navigateTo(itemUrl(item), { item })} href={itemUrl(item)}>{text}</a>;
